import React from 'react';

import { OrderFormContainer } from '../OrderForm/OrderFormContainer';
import { MembershipFailure } from './MembershipFailure';
import { MembershipForm } from './MembershipForm';
import { MembershipSuccess } from './MembershipSuccess';

export const MembershipContainer = (props) => {
  const backUrl = process.browser ? window.document.location.pathname : '/';

  return (
    <OrderFormContainer
      form={<MembershipForm {...props} />}
      success={<MembershipSuccess />}
      fail={<MembershipFailure backUrl={backUrl} />}
    />
  );
};
